import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import utils from '@/utils/utils';
import error from '@/assets/error.png';
import dd from '@/utils/dd';
import "./style.scss";

function CenterSecond(props: any) {
    const { id, list, compId, mark, pId, mallTest } = props;
    const [carImgH, setCarImgH] = useState<any>('auto');

    const clickCenterSecond = (v: any) => {
        if (v.link) {
            window.location.href = utils.linkUrl(v.link, 200013, mallTest);
        }
        // 点击埋点
        let extendParams = {
            ...dd.ep,
            providerId: pId,
            positionId: v.key,
            linkUrl: v.link,
            // 组件id
            compId,
            mallTest
        };
        extendParams = utils.formatParams(extendParams);
        utils.pvTrackLogger(
            'click',
            'ec_topic_mall_efgtupian_click',
            dd.baseParams,
            extendParams
        );

    };

    useEffect(() => {
        if (list.length > 0 && mark.pageType === "mall") {
          // 曝光埋点
          let extendParams = {
            ...dd.ep,
            providerId: pId,
            compId,
            mallTest,
          };
          extendParams = utils.formatParams(extendParams);
          utils.pvTrackLogger(
            "show",
            "ec_topic_mall_efgtupian_show",
            dd.baseParams,
            extendParams
          );
        }
    }, [list, JSON.stringify(mark)]);

    useEffect(() => {
        // @ts-ignore
        const carImgH = document.getElementById('carImg_2')?.offsetWidth * 0.5 ;
        if (carImgH > 0) {
            setCarImgH(() => carImgH);
        }
        // @ts-ignore
    }, [document.getElementById('carImg_2')?.offsetWidth]);

    return (
        <div key={id} className='tabHome-item centerTwo'>
            {
                list.map((v: any) => {
                    return (
                        <img
                            id='carImg_2'
                            key={v.key}
                            src={v.picture}
                            onClick={() => clickCenterSecond(v)}
                            onError={() => {
                                let _img: any = document.getElementById(`carImg_2`);
                                _img.src = error;
                            }}
                            style={{ height: carImgH }}
                        />
                    )
                })
            }
        </div>
    );
}

export default CenterSecond;
